module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAATlBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzNGYEBkkU13slV5aj3KpUf/zE1tLzmwLkDdLkQzPzdomU9EQzbXr0hALzW7LkFyqlPywkvSLkN7bBYpAAAACHRSTlMAYL//ACDP71kzCuAAAADiSURBVHgB7dZRkkQwFIVhHDQhhEZ373+jk0mlUm5qal6cp3a/BfwPiJxC/UcppcoKF1Rl7RV13bS4qG1+Q80Dlz0aH2pB0NZFCYqyqEBRFSC5R6jrjdd3EIbReuMAYZqdN09/hJbVROuC5LnZaHsi2Q8XHXseWl4meS2p87bJO5X2j0s+exZazcmKaLMnG6LDnRwy1BmhQzBYYUAwOWESod4IPYLRCiOC2QmzCJkMAptB4DI3CBEeNun1sz5I2hGhHlr+b+SCG4RoFyTtymaNCNqsYQ4tjzP9SDSkIQ1p6OtCP5OHToVK/7hIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f6a5.png
// module id = 1279
// module chunks = 0